// extracted by mini-css-extract-plugin
module.exports = {"placeholderItem":"Loader_placeholderItem__1F0Os","load":"Loader_load__k1Sc2"};